import {useMemo} from 'react'

import {APP_API_URL} from '#/lib/constants.ts'
import {createFullHandle} from '#/lib/strings/handles.ts'
import {useServiceQuery} from '#/state/queries/service'

export const usePdsDomain = () => {
  const {data: serviceDescription} = useServiceQuery(APP_API_URL)
  return useMemo(() => {
    return (
      serviceDescription?.availableUserDomains?.[0] ??
      new URL(APP_API_URL).hostname
    ).replace(/^\.+/, '')
  }, [serviceDescription])
}

export const getHandleParts = (pdsDomain: string, handle: string) => {
  const localPart = handle
    .replace(new RegExp(`\.${pdsDomain.replace(/\./g, '\\.')}$`), '')
    .replace(/\..*$/, '')
  const fullHandle = createFullHandle(localPart, pdsDomain)
  return {localPart, fullHandle}
}
